'use strict';

// src/common/type.ts
var NotificationWorkspaceType = /* @__PURE__ */ ((NotificationWorkspaceType2) => {
  NotificationWorkspaceType2["NEW_USER"] = "workspace:new:user";
  return NotificationWorkspaceType2;
})(NotificationWorkspaceType || {});
var NotificationBoardType = /* @__PURE__ */ ((NotificationBoardType2) => {
  NotificationBoardType2["SHARED"] = "board:shared";
  NotificationBoardType2["EDITED"] = "board:edited";
  return NotificationBoardType2;
})(NotificationBoardType || {});
var NotificationBoardRowType = /* @__PURE__ */ ((NotificationBoardRowType2) => {
  NotificationBoardRowType2["ASSIGNED"] = "board:row:assigned";
  NotificationBoardRowType2["NEW_COMMENT"] = "board:row:comment:new";
  return NotificationBoardRowType2;
})(NotificationBoardRowType || {});
var NotificationMeetType = /* @__PURE__ */ ((NotificationMeetType2) => {
  NotificationMeetType2["SHARED"] = "meet:shared";
  NotificationMeetType2["REMINDER"] = "meet:reminder";
  return NotificationMeetType2;
})(NotificationMeetType || {});
var NotificationChannelType = /* @__PURE__ */ ((NotificationChannelType2) => {
  NotificationChannelType2["NEW"] = "channel:new";
  NotificationChannelType2["DELETE"] = "channel:delete";
  NotificationChannelType2["UPDATE"] = "channel:update";
  NotificationChannelType2["SHARED"] = "channel:shared";
  return NotificationChannelType2;
})(NotificationChannelType || {});
var NotificationChannelMessageType = /* @__PURE__ */ ((NotificationChannelMessageType2) => {
  NotificationChannelMessageType2["NEW"] = "channel:message:new";
  NotificationChannelMessageType2["DELETE"] = "channel:message:delete";
  NotificationChannelMessageType2["UPDATE"] = "channel:message:update";
  return NotificationChannelMessageType2;
})(NotificationChannelMessageType || {});
var NotificationVoiceChannelType = /* @__PURE__ */ ((NotificationVoiceChannelType2) => {
  NotificationVoiceChannelType2["NOTES_READY"] = "voiceChannel:notes:ready";
  NotificationVoiceChannelType2["INCOMING_CALL"] = "voiceChannel:call:incoming";
  return NotificationVoiceChannelType2;
})(NotificationVoiceChannelType || {});
var NotificationAIScheduleType = /* @__PURE__ */ ((NotificationAIScheduleType2) => {
  NotificationAIScheduleType2["INCOMING_CALL"] = "aiSchedule:call:incoming";
  return NotificationAIScheduleType2;
})(NotificationAIScheduleType || {});
var NotificationDocType = /* @__PURE__ */ ((NotificationDocType2) => {
  NotificationDocType2["NEW"] = "doc:new";
  NotificationDocType2["UPDATE"] = "doc:update";
  NotificationDocType2["DELETE"] = "doc:delete";
  NotificationDocType2["SHARED"] = "doc:shared";
  NotificationDocType2["NEW_COMMENT"] = "doc:comment";
  return NotificationDocType2;
})(NotificationDocType || {});
var NotificationToDoType = /* @__PURE__ */ ((NotificationToDoType2) => {
  NotificationToDoType2["COMPLETED"] = "todo:completed";
  NotificationToDoType2["SHARED"] = "todo:shared";
  return NotificationToDoType2;
})(NotificationToDoType || {});
var NotificationDriveType = /* @__PURE__ */ ((NotificationDriveType2) => {
  NotificationDriveType2["SHARED"] = "drive:shared";
  return NotificationDriveType2;
})(NotificationDriveType || {});

// src/common/status.ts
var NotificationStatus = /* @__PURE__ */ ((NotificationStatus2) => {
  NotificationStatus2["UNREAD"] = "unread";
  NotificationStatus2["READ"] = "read";
  return NotificationStatus2;
})(NotificationStatus || {});

exports.NotificationAIScheduleType = NotificationAIScheduleType;
exports.NotificationBoardRowType = NotificationBoardRowType;
exports.NotificationBoardType = NotificationBoardType;
exports.NotificationChannelMessageType = NotificationChannelMessageType;
exports.NotificationChannelType = NotificationChannelType;
exports.NotificationDocType = NotificationDocType;
exports.NotificationDriveType = NotificationDriveType;
exports.NotificationMeetType = NotificationMeetType;
exports.NotificationStatus = NotificationStatus;
exports.NotificationToDoType = NotificationToDoType;
exports.NotificationVoiceChannelType = NotificationVoiceChannelType;
exports.NotificationWorkspaceType = NotificationWorkspaceType;
